import { Clock } from "lucide-react";
import { Reveal, Chapter } from "@/components/Shared";

const DAYS = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday",
];

const Hours = () => (
  <section id="hours" data-testid="hours-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="pointer-events-none absolute top-20 right-0 h-96 w-96 rounded-full bg-amber-200/30 blur-3xl" />
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:items-center">
      <Reveal>
        <Chapter num="03" label="Hours of Care" />
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.12] text-deepteal-dark">
          We're open <em className="italic text-terracotta">7 days a week</em> — because life doesn't stop on weekends.
        </h2>
        <p className="mt-5 max-w-lg text-base sm:text-lg leading-relaxed text-slate-600">
          Dependable childcare in Halethorpe, MD from early morning to early evening, every single
          day. Weekend childcare, holiday-week coverage, and before-and-after school care all under
          one roof.
        </p>
        <div
          data-testid="hours-highlight"
          className="mt-8 inline-flex items-center gap-4 rounded-3xl bg-terracotta px-7 py-5 text-amber-50 shadow-xl shadow-terracotta/30"
        >
          <Clock className="h-9 w-9 shrink-0" strokeWidth={1.6} />
          <div>
            <p className="font-serif text-xl sm:text-2xl font-semibold">Open 7 Days a Week!</p>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-100/90">
              6:00 AM – 6:00 PM · Mon–Sun
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="overflow-hidden rounded-3xl border border-amber-900/10 bg-white/80 shadow-xl shadow-deepteal/10 backdrop-blur">
          <div className="border-b border-amber-900/10 bg-deepteal px-7 py-4">
            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-amber-200">
              Weekly Schedule
            </p>
          </div>
          <ul data-testid="hours-list">
            {DAYS.map((day, i) => (
              <li
                key={day}
                data-testid={`hours-row-${day.toLowerCase()}`}
                className={`flex items-center justify-between px-7 py-4 transition-colors duration-300 hover:bg-amber-50 ${
                  i !== DAYS.length - 1 ? "border-b border-amber-900/8 border-amber-900/10" : ""
                }`}
              >
                <span className="flex items-center gap-3 text-sm sm:text-base font-semibold text-deepteal-dark">
                  <span className={`h-1.5 w-1.5 rounded-full ${i > 4 ? "bg-terracotta" : "bg-amber-500"}`} />
                  {day}
                  {i > 4 && (
                    <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-terracotta border border-terracotta/30 rounded-full px-2 py-0.5">
                      Weekend
                    </span>
                  )}
                </span>
                <span className="font-mono text-xs sm:text-sm font-semibold text-slate-600">
                  6:00 AM – 6:00 PM
                </span>
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Hours;
